
import { Subject, Observable } from 'rxjs';
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class EventService {

  private subject = new Subject<any>();

  send(message: any) {
    this.subject.next(message);
  }

  get(): Observable<any> {
    return this.subject.asObservable();
  }

}
